/**
 * This module will be bundled into early requester scripts. Be mindful when adding module dependencies.
 */
import quickFetch from 'quick-fetch';
export function quickFetchOptinAvailability(optinName) {
  quickFetch.makeEarlyRequest(`optin-${optinName}`, {
    url: quickFetch.getApiUrl(`/optins/v1/availability/${optinName}`),
    timeout: 15000,
    dataType: 'json',
    contentType: 'application/json',
    type: 'GET',
    whenFinished(availability) {
      availability.optinView = availability.state === 'OPTED_IN' ? 'NEW' : 'CURRENT';
    }
  });
}